import { extractCssVariableValue } from '~/utils/extract-css-variable-value'
import { hslToHex } from '~/utils/hsl-to-hex'

const hslCssVariablePattern = /^\d+(\.\d+)?\s+\d+(\.\d+)?%\s+\d+(\.\d+)?%$/

export const cssVariableToHex = (variableName: string) => {
  try {
    const rawValue = extractCssVariableValue(variableName).trim()
    if (!rawValue || !hslCssVariablePattern.test(rawValue)) return null

    return hslToHex(rawValue)
  } catch {
    return null
  }
}
